import React, { useState, useEffect } from 'react';
import { X, CheckCircle, AlertCircle, Info, DollarSign, ShoppingBag, Users } from 'lucide-react';

const Toast = ({ message, type = 'info', duration = 4000, onClose, title }) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      if (onClose) {
        setTimeout(onClose, 300); // Wait for fade out animation
      }
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  // Match your NotificationBell icon logic exactly
  const getIconClass = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100 text-green-600';
      case 'error':
        return 'bg-red-100 text-red-600';
      case 'warning':
        return 'bg-yellow-100 text-yellow-600';
      case 'info':
      default:
        return 'bg-blue-100 text-blue-600';
    }
  };

  const getIconComponent = () => {
    switch (type) {
      case 'success':
        return ShoppingBag; // Matches your 'tokens_earned' type
      case 'error':
        return AlertCircle;
      case 'warning':
        return AlertCircle;
      case 'info':
      default:
        return Info;
    }
  };

  const IconComponent = getIconComponent();

  return (
    <div
      className={`fixed top-4 right-4 z-50 w-80 transition-all duration-300 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2'
      }`}
    >
      {/* Match your NotificationBell dropdown styling exactly */}
      <div className="bg-white rounded-lg shadow-lg border">
        <div className="px-4 py-3">
          <div className="flex">
            <div className={`p-2 rounded-full mr-3 ${getIconClass()}`}>
              <IconComponent size={16} />
            </div>
            <div className="flex-1">
              <div className="flex justify-between">
                <h4 className="font-medium text-sm">{title || 'Notification'}</h4>
                <div className="flex items-center">
                  <span className="text-xs text-gray-500 mr-2">now</span>
                  <button 
                    onClick={() => {
                      setIsVisible(false);
                      if (onClose) setTimeout(onClose, 300);
                    }}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <X size={14} />
                  </button>
                </div>
              </div>
              <p className="text-sm text-gray-600 mt-1">{message}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Toast;